import styled from 'styled-components';

export const NotificationWrap = styled.div`
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ color }) => color};
  padding: 12px 24px;
  margin-bottom: 1.7rem;
  font-size: 16px;
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #1b1b1b;

  &.ltr {
  }
  &.rtl {
  }
`;
